<script setup lang="ts">
import { useCdnImages } from '../../../composables/use-cdn-images'

const { cdnImageUrl } = useCdnImages()
</script>

<template>
  <div class="bx-header__logo-wrapper">
    <a class="bx-header__logo"
       title="https://www.tvmovie.de/"
       href="/">
      <img :src="cdnImageUrl('/images/tvmovie/tvmovie-logo.svg')"
           alt="TV Movie Logo"
           width="297"
           height="80">
    </a>
    <div class="bx-header__epg-quicklinks">
      <a href="/tv/programm-jetzt">Jetzt</a>
      <a href="/tv/fernsehprogramm-heute-abend">20:15</a>
    </div>
  </div>
</template>
